import { AddNewActionItemsAttachmentDetails } from "../common/action-attachment.model";
import { AddNewActionItemsAssignementDeatails } from "../common/assignment-details.model";
import { AddNewItemAction } from "./add-new-action-item.model";

export class AddNewItemActionResponseDto {
    items: AddNewItemAction[] = [];
    attachments!: AddNewActionItemsAttachmentDetails[];
    assignmentDetails!: AddNewActionItemsAssignementDeatails;
}